import { AudioBuilderContext } from "../AudioBuilderContext";
import { Curve } from "./Curve";
import { CurveModifier } from "./modifiers/CurveModifier";

export class CurveModifierStack
{
  modifiers:CurveModifier[] = [];

  modify( curve:Curve, context:AudioBuilderContext )
  {
    for ( let i = 0; i < this.modifiers.length; i++ )
    {
      curve = this.modifiers[ i ].modify( curve, context );
    }

    return curve;
  }
}